var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 120,
    viewBox: "0 0 104 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "l0m6toe6ia"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 53",
    transform: "translate(0 -.018)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h42v42H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9412"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9416"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 40",
    style: {
      fill: "#5293a5"
    },
    d: "M0 0h104v120H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 41",
    style: {
      clipPath: "url(#l0m6toe6ia)"
    },
    transform: "translate(31 39.018)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 52",
    d: "M27.988 13.994H13.994v13.994h13.994zm13.994 4.665v-4.665h-4.665V9.329a4.678 4.678 0 0 0-4.665-4.665h-4.664V0h-4.665v4.665h-4.664V0h-4.665v4.665H9.329a4.678 4.678 0 0 0-4.664 4.664v4.665H0v4.665h4.665v4.665H0v4.665h4.665v4.665a4.678 4.678 0 0 0 4.665 4.665h4.665v4.665h4.665v-4.667h4.665v4.665h4.665v-4.665h4.665a4.678 4.678 0 0 0 4.665-4.665v-4.664h4.665v-4.665h-4.668v-4.664zm-9.33 13.993H9.329V9.329h23.323z",
    style: {
      fill: "#fff"
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.987f7130c8700044a232b681c909ee21.svg";
export { ForwardRef as ReactComponent };